import { render } from "./QuestionBankDetails.vue?vue&type=template&id=0c60e309&scoped=true"
import script from "./QuestionBankDetails.vue?vue&type=script&lang=js"
export * from "./QuestionBankDetails.vue?vue&type=script&lang=js"

import "./QuestionBankDetails.vue?vue&type=style&index=0&id=0c60e309&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c60e309"]])

export default __exports__